export const audioBitRates = ["6k", "10k", "20k", "40k", "96k", "192k", "510k"];
